// dočasný kontejner - obsahující odkaz na kontejner po načtení ajaxu
// e.g. ProductFilter komponenta.. celý kontejner je definován uvnitř jednoho cshtml, aby bylo možné po načtení přenačíst kontejner tak tento element obsahuje odkaz na kontejner uvnitř cshtml, do kterého se po načtení ajaxu přenačte
class BlockContainer extends HTMLElement
{
    connectedCallback()
    {
        this.remove();
    }
}

class DiscountFlag extends HTMLElement
{
    connectedCallback()
    {
        this.onPriceLoadedAsync = async event =>
        {
            var data = event.detail.data;

            if (data.productId != this.dataset.productId || data.quantityUnit != this.dataset.unit)
                return;

            var actionFlag = this.dataset.actionFlag && this.dataset.actionFlag.toLowerCase() == "true";

            if (data.price == data.oldPrice && !actionFlag)
            {
                this.remove();

                return;
            }
            else if (actionFlag)
            {
                var actionElement = await category.createActionFlagAsync(data, this.className);

                this.replaceWith(actionElement);

                return;
            }

            var newElement = await category.createDiscountFlagAsync(data, this.className);

            this.replaceWith(newElement);
        };

        document.addEventListener("onPriceLoaded", this.onPriceLoadedAsync);
    }

    disconnectedCallback()
    {
        document.removeEventListener("onPriceLoaded", this.onPriceLoadedAsync);
    }
}

// kontejner pro skripty načítane přes Ajax
class ScriptContainer extends HTMLElement
{
    connectedCallback()
    {
        const parent = this.parentNode;

        let script = document.createElement("script");
        script.textContent = this.textContent;

        parent.appendChild(script);

        this.remove();
    }
}

class QuantityElement extends HTMLElement
{
    connectedCallback()
    {
        const parent = this.parentNode;

        var input = parent.querySelector("input[data-quantity]");

        if (!input)
            return;

        var form = input.form;

        form.addEventListener("reset", () =>
        {
            setTimeout(() =>
            {
                input.value = input.attributes.min.value || '1';

                if (form.dataset.quantity)
                    form.dataset.quantity = input.value;
            }, 1);
        });
    }
}

class SweetAlertElement extends HTMLElement
{
    connectedCallback()
    {
        const rawOptions = this.dataset.options;

        if (!rawOptions)
        {
            this.remove();

            return;
        }

        const textarea = document.createElement("textarea");
        textarea.innerHTML = rawOptions;

        const options = JSON.parse(textarea.value);

        Swal.fire(options);

        textarea.remove();
        this.remove();
    }
}

customElements.define("block-container", BlockContainer);
customElements.define("discount-flag", DiscountFlag);
customElements.define("script-container", ScriptContainer);
customElements.define("quantity-input", QuantityElement);
customElements.define("sweet-alert", SweetAlertElement);

//export default abraCustomElements;